import { Component, OnInit } from '@angular/core';
import { DashboardRestService } from '../dashboard-rest.service';
import { DataFormatService, GridTableDataSource } from '../../../libraries/libraries.module';
import { DashboardDealerRestService } from './dashboard-dealer-rest.service';

@Component({
  selector: 'app-dashboard-dealer',
  templateUrl: 'dashboard-dealer.component.html',
  styleUrls: ['../dashboard.component.scss']
})
export class DashboardDealerComponent implements OnInit {
  totalCreditNote = '-';

  creditNoteDataSource: GridTableDataSource<any> = new GridTableDataSource<any>();

  constructor(private api: DashboardDealerRestService, private dataFormatService: DataFormatService) {}

  ngOnInit() {
    this.loadSummaryData();
  }

  formatRupiah = this.dataFormatService.formatRupiah;

  loadSummaryData() {
    this.api.getCreditNoteInsight().subscribe((data: any) => {
      if (data.totalCreditNote) {
        this.totalCreditNote = this.formatRupiah(data.totalCreditNote);
      }
    });
  }
}
